import { createFileRoute } from '@tanstack/react-router';
import { TriggeredRedirectRoute } from './-journeys-redirects';

function TriggeredIndexRoute() {
  const { workspaceId } = Route.useParams();
  return <TriggeredRedirectRoute workspaceId={workspaceId} />;
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/triggered/')({
  component: TriggeredIndexRoute,
});
